import * as auditSlice from '../audit/auditSlice';
import * as settingsSlice from '../settings/settingsSlice';
import * as weightingsSlice from '../weightings/weightingsSlice';
import * as resultsSlice from '../results/resultsSlice';
import * as clientConfigurationSlice from '../clientConfiguration/clientConfigurationSlice';
import * as identitySlice from '../identity/identitySlice';
import * as usersSlice from '../users/usersSlice';
import * as accessGroupsSlice from '../accessGroups/accessGroupsSlice';
import * as ivazSlice from '../ivaz/ivazSlice';
import * as reportsSlice from '../reports/reportsSlice';
import * as destPointSlice from '../destPoint/destPointSlice';
import * as cardsSlice from '../cards/cardsSlice';
import * as contractsSlice from '../contracts/contractsSlice';
import * as vehiclesSlice from '../vehicles/vehiclesSlice';
import * as productsSlice from '../products/productsSlice';
import * as driversSlice from '../drivers/driversSlice';
import * as customersSlice from '../customers/customersSlice';
import * as dynamicTablesSlice from '../dynamicTables/dynamicTablesSlice';
import * as tableSlice from '../table/tableSlice';

export const watchList = [
 // audit
 auditSlice.getTableFailure,
 auditSlice.createItemSuccess,
 auditSlice.createItemFailure,
 auditSlice.updateItemSuccess,
 auditSlice.updateItemFailure,
 auditSlice.deleteItemsSuccess,
 auditSlice.deleteItemsFailure,
 auditSlice.deleteItemSuccess,
 auditSlice.deleteItemFailure,
 // settings
 settingsSlice.getTableFailure,
 settingsSlice.createItemSuccess,
 settingsSlice.createItemFailure,
 settingsSlice.updateItemSuccess,
 settingsSlice.updateItemFailure,
 settingsSlice.deleteItemsSuccess,
 settingsSlice.deleteItemsFailure,
 settingsSlice.deleteItemSuccess,
 settingsSlice.deleteItemFailure,
 // weightings
 weightingsSlice.getTableFailure,
 weightingsSlice.createItemSuccess,
 weightingsSlice.createItemFailure,
 weightingsSlice.updateItemSuccess,
 weightingsSlice.updateItemFailure,
 weightingsSlice.deleteItemsSuccess,
 weightingsSlice.deleteItemsFailure,
 weightingsSlice.deleteItemSuccess,
 weightingsSlice.deleteItemFailure,
 // results
 resultsSlice.getTableFailure,
 resultsSlice.createItemSuccess,
 resultsSlice.createItemFailure,
 resultsSlice.updateItemSuccess,
 resultsSlice.updateItemFailure,
 resultsSlice.deleteItemsSuccess,
 resultsSlice.deleteItemsFailure,
 resultsSlice.deleteItemSuccess,
 resultsSlice.deleteItemFailure,
 resultsSlice.approveResultSuccess,
 resultsSlice.approveResultFailure,
 // destPoint
 destPointSlice.getTableFailure,
 destPointSlice.createItemSuccess,
 destPointSlice.createItemFailure,
 destPointSlice.updateItemSuccess,
 destPointSlice.updateItemFailure,
 destPointSlice.deleteItemsSuccess,
 destPointSlice.deleteItemsFailure,
 destPointSlice.deleteItemSuccess,
 destPointSlice.deleteItemFailure,
 // cards
 cardsSlice.getTableFailure,
 cardsSlice.createItemSuccess,
 cardsSlice.createItemFailure,
 cardsSlice.updateItemSuccess,
 cardsSlice.updateItemFailure,
 cardsSlice.deleteItemsSuccess,
 cardsSlice.deleteItemsFailure,
 cardsSlice.deleteItemSuccess,
 cardsSlice.deleteItemFailure,
 // contracts
 contractsSlice.getTableFailure,
 contractsSlice.createItemSuccess,
 contractsSlice.createItemFailure,
 contractsSlice.updateItemSuccess,
 contractsSlice.updateItemFailure,
 contractsSlice.deleteItemsSuccess,
 contractsSlice.deleteItemsFailure,
 contractsSlice.deleteItemSuccess,
 contractsSlice.deleteItemFailure,
 // vehicles
 vehiclesSlice.getTableFailure,
 vehiclesSlice.createItemSuccess,
 vehiclesSlice.createItemFailure,
 vehiclesSlice.updateItemSuccess,
 vehiclesSlice.updateItemFailure,
 vehiclesSlice.deleteItemsSuccess,
 vehiclesSlice.deleteItemsFailure,
 vehiclesSlice.deleteItemSuccess,
 vehiclesSlice.deleteItemFailure,
 // products
 productsSlice.getTableFailure,
 productsSlice.createItemSuccess,
 productsSlice.createItemFailure,
 productsSlice.updateItemSuccess,
 productsSlice.updateItemFailure,
 productsSlice.deleteItemsSuccess,
 productsSlice.deleteItemsFailure,
 productsSlice.deleteItemSuccess,
 productsSlice.deleteItemFailure,
 // drivers
 driversSlice.getTableFailure,
 driversSlice.createItemSuccess,
 driversSlice.createItemFailure,
 driversSlice.updateItemSuccess,
 driversSlice.updateItemFailure,
 driversSlice.deleteItemsSuccess,
 driversSlice.deleteItemsFailure,
 driversSlice.deleteItemSuccess,
 driversSlice.deleteItemFailure,
 // customers
 customersSlice.getTableFailure,
 customersSlice.createItemSuccess,
 customersSlice.createItemFailure,
 customersSlice.updateItemSuccess,
 customersSlice.updateItemFailure,
 customersSlice.deleteItemsSuccess,
 customersSlice.deleteItemsFailure,
 customersSlice.deleteItemSuccess,
 customersSlice.deleteItemFailure,
 // dynamicTables
 dynamicTablesSlice.getTableFailure,
 dynamicTablesSlice.createItemSuccess,
 dynamicTablesSlice.createItemFailure,
 dynamicTablesSlice.updateItemSuccess,
 dynamicTablesSlice.updateItemFailure,
 dynamicTablesSlice.deleteItemsSuccess,
 dynamicTablesSlice.deleteItemsFailure,
 dynamicTablesSlice.deleteItemSuccess,
 dynamicTablesSlice.deleteItemFailure,
 // identity
 identitySlice.identityLoginFailure,
 identitySlice.identityLogoutSuccess,
 identitySlice.identityLogoutFailure,
 identitySlice.identityRefreshTokenFailure,
 identitySlice.identityMicrosoftFailure,
 identitySlice.identityMicrosoftCallbackFailure,
 identitySlice.identityGoogleFailure,
 identitySlice.identityGoogleCallbackFailure,
 identitySlice.identityVerify2FAFailure,
 identitySlice.identityForgotPasswordFailure,
 identitySlice.identityResetPasswordFailure,
 identitySlice.identityGenerate2FACodeFailure,
 identitySlice.identitySetVerificationSuccess,
 identitySlice.identitySetVerificationFailure,
 identitySlice.identityConfirmVerificationSuccess,
 identitySlice.identityConfirmVerificationFailure,
 identitySlice.identitySetTotpSuccess,
 identitySlice.identitySetTotpFailure,
 identitySlice.identityVerifyTotpSuccess,
 identitySlice.identityVerifyTotpFailure,
 identitySlice.identityRevokeTokenSuccess,
 identitySlice.identityRevokeTokenFailure,
 identitySlice.identityRevokeAllTokensSuccess,
 identitySlice.identityRevokeAllTokensFailure,
 usersSlice.usersGetSelfFailure,
 usersSlice.usersCreateUserSuccess,
 usersSlice.usersCreateUserFailure,
 usersSlice.createItemSuccess,
 usersSlice.createItemFailure,
 usersSlice.updateItemSuccess,
 usersSlice.updateItemFailure,
 usersSlice.usersUpdateSelfSuccess,
 usersSlice.usersUpdateSelfFailure,
 usersSlice.usersGetUserGroupsFailure,
 usersSlice.usersGetUserGroupFailure,
 usersSlice.usersCreateUserGroupSuccess,
 usersSlice.usersCreateUserGroupFailure,
 usersSlice.usersUpdateUserGroupSuccess,
 usersSlice.usersUpdateUserGroupFailure,
 usersSlice.usersGetStructureFailure,
 usersSlice.usersGetUserAccessGroupsFailure,
 usersSlice.usersGetSelfAccessGroupFailure,
 usersSlice.usersGetSelfAccessGroupsFailure,
 usersSlice.usersGenerateApiKeySuccess,
 usersSlice.usersGenerateApiKeyFailure,
 usersSlice.usersAttachDatabaseSuccess,
 usersSlice.usersAttachDatabaseFailure,
 usersSlice.usersDetachDatabaseSuccess,
 usersSlice.usersDetachDatabaseFailure,
 // accessGroups
 accessGroupsSlice.getTableFailure,
 accessGroupsSlice.createItemSuccess,
 accessGroupsSlice.createItemFailure,
 accessGroupsSlice.updateItemSuccess,
 accessGroupsSlice.updateItemFailure,
 accessGroupsSlice.accessGroupsGetRolesFailure,
 accessGroupsSlice.accessGroupsGetRolesTableFailure,
 accessGroupsSlice.accessGroupsAddRoleSuccess,
 accessGroupsSlice.accessGroupsAddRoleFailure,
 accessGroupsSlice.accessGroupsCreateRoleSuccess,
 accessGroupsSlice.accessGroupsCreateRoleFailure,
 accessGroupsSlice.accessGroupsUpdateRoleSuccess,
 accessGroupsSlice.accessGroupsUpdateRoleFailure,
 accessGroupsSlice.accessGroupsDeleteRoleSuccess,
 accessGroupsSlice.accessGroupsDeleteRoleFailure,
 accessGroupsSlice.accessGroupsRemoveRoleSuccess,
 accessGroupsSlice.accessGroupsRemoveRoleFailure,
 // clientConfiguration
 //  clientConfigurationSlice.getClientConfigurationsSuccess,
 clientConfigurationSlice.getClientConfigurationsFailure,
clientConfigurationSlice.getClientConfigurationSelfFailure,
 // reports
 reportsSlice.reportsGenerateSuccess,
 reportsSlice.reportsGenerateFailure,
 // ivaz
 ivazSlice.sendIVAZSuccess,
 ivazSlice.sendIVAZFailure,
 // table
 tableSlice.getTableFailure,
 tableSlice.createItemSuccess,
 tableSlice.createItemFailure,
 tableSlice.updateItemSuccess,
 tableSlice.updateItemFailure,
 tableSlice.deleteItemsSuccess,
 tableSlice.deleteItemsFailure,
 tableSlice.deleteItemSuccess,
 tableSlice.deleteItemFailure,
];
